// Add your custom JS here!!!

// Add a class to the body tag based on the screen width based on bootstrap breakpoints
function addMobileClass() {
    if (window.matchMedia("(max-width: 1199px)").matches) {
        document.body.classList.add('is_mobile');
    } else {
        document.body.classList.add('is_desktop');
        document.body.classList.remove('is_mobile');
    }
}

// Run the function on initial load
addMobileClass();

// Optionally, run the function on window resize
window.addEventListener('resize', addMobileClass);

// Remove white space at the bottom of the iframe
document.querySelector('iframe').style.display = 'block';
document.querySelector('iframe').style.margin = '0';
document.querySelector('iframe').style.padding = '0';